import { osName, osVersion } from 'react-device-detect';
import { feathersCreateData } from '../services';
import { isEmpty } from './arrays';
import { getDeviceIp } from './core-actions';

export const sendLogs = async (user, inf, type, deviceReduce, getDeviceData ) => {
    try {
        const ip = await getDeviceIp()
        const info = JSON.stringify(inf)
        // console.log( { ip, device, info, user, type  })
        if(localStorage.caja_app !== undefined)  {
            if (isEmpty(deviceReduce)) {
                // si no hay data del dispositivo
                const dataDevice = await getDeviceData(user)
                const {data, info }= dataDevice
                const { ip, device, mac } = data
                feathersCreateData('server-logs', { ip, device, info: JSON.stringify(info), user: data.user, type, mac  })()
            } else {
                const { ip, device, mac } = deviceReduce
                feathersCreateData('server-logs', { ip, device, info, user, type, mac  })()
            }
        } else {
            const device =  `${osName} ${osVersion}`
            feathersCreateData('server-logs', { ip, device, info, user, type, mac: 'NAVEGADOR'  })()
        } 
    } catch (error) {
        
    }
}